require('./securityKitRow.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
import classNames from 'classnames';
// @ constants
const { EURO_TEXT } = require('constants/index');
// @ helpers
const { formatCurrency } = require('utilities/currencyHelper');
const { FormattedText } = require('core/i18n').i18n;

class SecurityKitRow extends React.PureComponent {

	constructor(props) {
		super(props);
	}

	render() {
    const { title, kit, showAmount } = this.props;
		const titleClassName = classNames('security-kit-row__title', {
				'security-kit-row__title__show-amount': showAmount,
		});
		return(
    <OKTable>
        <OKTableRow className="security-kit-row">
            <OKTableCell className={titleClassName}>
                <span className="security-kit-row__title__initial">{title.initial}</span>
                <span className="security-kit-row__title__parenthesis">{title.parenthesis}</span>
            </OKTableCell>
            <OKTableCell className="security-kit-row__kit">
                <span>{kit.type}</span>
                { showAmount &&
                <p className="security-kit-row__kit__amount">
                    <FormattedText
                        injectedStrings={kit.amount}
                        value={`securityKit-resumeKitCustom`}
                    />
                    <span>{formatCurrency(EURO_TEXT)}</span>
                </p>
                }
            </OKTableCell>
        </OKTableRow>
    </OKTable>
    )
	}
}

SecurityKitRow.propTypes = {
	title: PropTypes.string.isRequired,
  kit: PropTypes.object.isRequired,
  showAmount: PropTypes.bool.isRequired
}

module.exports.constructor = SecurityKitRow
module.exports.SecurityKitRow = SecurityKitRow
